import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./MobileHeader.css";
// 

import OnlyLogoname from "./OnlyLogoname";
import logo from "./Images/logo_bg1.png";
import LanguageDropdown from "./LanguageDropdown";

import {
    FaFacebook,
    FaYoutube,
    FaInstagram,
    FaLinkedin,
    FaPhone,
    FaChevronDown,
    FaHome,
    FaEnvelope,
    FaBars,
    FaTimes,
    FaBuilding,
    FaLandmark,
    FaWpforms,
    FaIndustry
} from "react-icons/fa";

export default function MobileHeader() {
    const [mobileMenu, setMobileMenu] = useState(false);
    const [servicesDropdown, setServicesDropdown] = useState(false);
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
        setMobileMenu(false);
        setServicesDropdown(false);
    };

    const navLinks = [
        { path: "/", label: "Home", icon: <FaHome /> },
        { path: "/FinanceCalculator", label: "Calculator" },
        {
            path: "#",
            label: "Property",
            icon: <FaChevronDown />,
            submenu: [
                { path: "/properties/industrial", label: "Industrial Properties" },
                { path: "/properties/residential", label: "Residential Properties" },
                { path: "/properties/commercial", label: "Commercial Properties" },
                { path: "/properties/land", label: "Land Properties" },
                { path: "/properties/LatestProperties", label: "Latest Properties" },



                { path: "/FeaturedProperties", label: "Featured Properties" },
               
            ]
        },
        { path: "/propertie", label: "All Properties" },
        { path: "/About", label: "About Us" },
        { path: "/PrivacyPolicy", label: "Privacy Policy" },
        { path: "/TermsConditions", label: "Terms Conditions" },
       
        // { path: "/Careers", label: "Careers" }
    ];

    // const propertyTypes = [
    //     {
    //         id: 1,
    //         path: "/properties/industrial",
    //         label: "Industrial",
    //         icon: <FaIndustry />,
    //         className: "mobile-industrial"
    //     },
    //     {
    //         id: 2,
    //         path: "/properties/residential",
    //         label: "Residential",
    //         icon: <FaHome />,
    //         className: "mobile-residential"
    //     },
    //     {
    //         id: 3,
    //         path: "/properties/commercial",
    //         label: "Commercial",
    //         icon: <FaBuilding />,
    //         className: "mobile-commercial"
    //     },
    //     {
    //         id: 4,
    //         path: "/properties/land",
    //         label: "Plot & Land",
    //         icon: <FaLandmark />,
    //         className: "mobile-land"
    //     }
    // ];

    return (
        <>






            {/* ===== Mobile Mini Top Bar ===== */}
            <div className="mh-mini-topbar">
                <div className="mh-mini-container">

                    {/* Mobile Number */}
                    <a href="tel:+918487916787" className="mh-mini-phone">
                        +91 84879 16787
                    </a>

                    {/* Social Icons */}
                    <div className="mh-mini-social">
 

                        <a
                            href="https://www.youtube.com/channel/UCxYJ1sBCI22V-ynJ63XhHYg"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mh-mini-social-icon"
                        >
                            <FaYoutube />
                        </a>


                        
                        <a
                            href="https://www.facebook.com/bgrealstate360"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mh-mini-social-icon"
                        >
                            <FaFacebook />
                        </a>
                        <a
                            href="https://www.instagram.com/bgrealstate360"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mh-mini-social-icon"
                        >
                            <FaInstagram />
                        </a>
                    </div>

                </div>
            </div>





            {/* Mobile Top Bar */}
            
            <div className="mobile-top-bar">
                <div className="mobile-top-container">

                    <OnlyLogoname />

                    <div className="mobile-top-actions">

                        <LanguageDropdown />

                        <button
                            className="mobile-menu-toggle"
                            onClick={() => setMobileMenu(!mobileMenu)}
                            aria-label="Toggle menu"
                        >
                            {mobileMenu ? <FaTimes /> : <FaBars />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Navigation Menu */}
            {mobileMenu && (
                <div className="mobile-navigation-menu">
                    <div className="mobile-nav-overlay" onClick={() => setMobileMenu(false)}></div>

                    <div className="mobile-nav-content">
                        <div className="mobile-nav-header">
                            {/* Mobile menu में भी same logo */}
                            <div className="mobile-nav-logo">
                                <div className="mobile-nav-logo-image-wrapper">
                                    <img src={logo} alt="BG RealState360" className="mobile-nav-logo-image" />
                                </div>
                                <div className="mobile-nav-logo-text">
                                    <h3>BG RealEstate360</h3>
                                    <p>Industrial & Land Experts</p>
                                </div>
                            </div>
                            <button
                                className="mobile-nav-close"
                                onClick={() => setMobileMenu(false)}
                            >
                                <FaTimes />
                            </button>
                        </div>

                        <div className="mobile-nav-links">
                            {navLinks.map((link, index) => (
                                <div key={index} className="mobile-nav-item">
                                    {link.submenu ? (
                                        <div className="mobile-dropdown">
                                            <button
                                                className="mobile-nav-link mobile-dropdown-trigger"
                                                onClick={() => setServicesDropdown(!servicesDropdown)}
                                            >
                                                <span>{link.label}</span>
                                                <FaChevronDown className={`mobile-dropdown-icon ${servicesDropdown ? 'mobile-rotated' : ''}`} />
                                            </button>

                                            {servicesDropdown && (
                                                <div className="mobile-submenu">
                                                    {link.submenu.map((subItem, subIndex) => (
                                                        <button
                                                            key={subIndex}
                                                            className="mobile-submenu-link"
                                                            onClick={() => handleNavigation(subItem.path)}
                                                        >
                                                            {subItem.label}
                                                        </button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <button
                                            className="mobile-nav-link"
                                            onClick={() => handleNavigation(link.path)}
                                        >
                                            {link.label}
                                        </button>
                                    )}
                                </div>
                            ))}

                            {/* Quick Contact Section */}
                            <div className="mobile-quick-contact">
                                <button
                                    className="mobile-call-btn"
                                    onClick={() => {
                                        window.location.href = "tel:+918487916787";
                                        setMobileMenu(false);
                                    }}
                                >
                                    <FaPhone /> Call Now
                                </button>
                                <button
                                    className="mobile-email-btn"
                                    onClick={() => {
                                        handleNavigation("/ContactUs");
                                    }}
                                >
                                    <FaEnvelope /> Email Us
                                </button>
                            </div>

                            {/* Social Media Links */}
                            <div className="mobile-nav-social">
                                <h4 className="mobile-social-title">Follow Us</h4>
                                <div className="mobile-nav-social-icons">
                                    <a href="https://www.facebook.com/profile.php?id=61585309266874" className="mobile-nav-social-icon" target="_blank" rel="noopener noreferrer">
                                        <FaFacebook />
                                    </a>
                                    <a href="https://www.youtube.com/channel/UCxYJ1sBCI22V-ynJ63XhHYg" className="mobile-nav-social-icon" target="_blank" rel="noopener noreferrer">
                                        <FaYoutube />
                                    </a>
                                    <a href="https://www.instagram.com/bgrealstate360" className="mobile-nav-social-icon" target="_blank" rel="noopener noreferrer">
                                        <FaInstagram />
                                    </a>
                                    <a href="https://www.linkedin.com/feed" className="mobile-nav-social-icon" target="_blank" rel="noopener noreferrer">
                                        <FaLinkedin />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Mobile Bottom Bar */}
            <div className="mobile-bottom-bar">
                <button className="mobile-bottom-btn" onClick={() => navigate("/")}>
                    <FaHome />
                    <span>Home</span>
                </button>
                <button className="mobile-bottom-btn" onClick={() => navigate("/FinanceCalculator")}>
                    <FaBuilding />
                    <span>Calculator</span>
                </button>
                <button className="mobile-bottom-btn mobile-call-now" onClick={() => window.location.href = "tel:+918487916787"}>
                    <FaPhone />
                    <span>Call Now</span>
                </button>
              

                <button className="mobile-bottom-btn" onClick={() => navigate("/propertie")}>
                    < FaIndustry />
                    <span>Properties</span>
                </button>
                <button className="mobile-bottom-btn" onClick={() => navigate("/PropertyEnquiry")}>
                    <FaWpforms />
                    <span>Enquiry Form</span>
                </button>
            </div>

           

        </>
    );
}